import { Mail, Phone, IdCard } from "lucide-react";
import { useState } from "react";

const money = (n) => `$${(n ?? 0).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;


// Real profile photo when the user uploaded one, initials otherwise.
export const UserAvatar = ({ name, photo, size = "h-10 w-10 text-xs", testId }) => {
  const [err, setErr] = useState(false);
  const dims = size.split(" ").slice(0, 2).join(" ");
  if (photo && !err) {
    return <img src={photo} alt={name || ""} data-testid={testId} onError={() => setErr(true)}
      className={`${dims} shrink-0 rounded-full object-cover`} />;
  }
  const initials = (name || "?").split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";
  return (
    <span data-testid={testId}
      className={`grid ${size} shrink-0 place-items-center rounded-full bg-[#2340b5]/10 font-bold text-[#2340b5]`}>
      {initials}
    </span>
  );
};
export const timeAgo = (min) => {
  if (min == null || min >= 999999) return "—";
  if (min < 60) return `${min} min ago`;
  if (min < 1440) return `${Math.round(min / 60)} hour${min >= 120 ? "s" : ""} ago`;
  return `${Math.round(min / 1440)} day${min >= 2880 ? "s" : ""} ago`;
};

export const ROLE_STYLE = {
  driver: { label: "Driver", color: "#2340b5", bg: "#2340b512" },
  rider: { label: "Rider", color: "#7c3aed", bg: "#7c3aed12" },
  business: { label: "Business", color: "#0891b2", bg: "#0891b212" },
  admin: { label: "Admin", color: "#e4002b", bg: "#e4002b12" },
};

const STATUS_STYLE = {
  active: { label: "Active", sub: "Online", color: "#16a34a" },
  pending: { label: "Pending", sub: "Verification", color: "#f59e0b" },
  suspended: { label: "Suspended", sub: "Safety", color: "#e4002b" },
  banned: { label: "Banned", sub: "Fraud", color: "#e4002b" },
  frozen: { label: "Frozen", sub: "On hold", color: "#0891b2" },
};

export const StatusCell = ({ status, online }) => {
  const s = STATUS_STYLE[status] || STATUS_STYLE.active;
  const sub = status === "active" ? (online ? "Online" : "Offline") : s.sub;
  return (
    <div className="flex items-start gap-2">
      <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full" style={{ backgroundColor: s.color }} />
      <div>
        <p className="text-sm font-semibold" style={{ color: s.color }}>{s.label}</p>
        <p className="text-xs text-[#565b73]">{sub}</p>
      </div>
    </div>
  );
};

const VERIF_FIELDS = [
  { key: "email", label: "Email", Icon: Mail },
  { key: "phone", label: "Phone", Icon: Phone },
  { key: "id", label: "ID", Icon: IdCard },
];

export const VerificationCell = ({ verification }) => {
  const v = verification || {};
  return (
    <div className="flex items-center gap-1.5">
      {VERIF_FIELDS.map(({ key, label, Icon }) => {
        const ok = !!v[key];
        return (
          <span
            key={key}
            title={`${label}: ${ok ? "verified" : "not verified"}`}
            data-testid={`verif-${key}-${ok ? "ok" : "no"}`}
            className="grid h-6 w-6 place-items-center rounded-lg transition-colors"
            style={{ backgroundColor: ok ? "#16a34a" : "#eef1f8" }}
          >
            <Icon className="h-3.5 w-3.5" strokeWidth={2.2} style={{ color: ok ? "#fff" : "#c3cbe4" }} />
          </span>
        );
      })}
    </div>
  );
};

export const Stars = ({ rating, count }) => {
  if (rating == null) return <span className="text-sm text-[#565b73]">—<br /><span className="text-xs">(0)</span></span>;
  const full = Math.floor(rating);
  return (
    <div>
      <div className="flex items-center gap-0.5">
        {[0, 1, 2, 3, 4].map((i) => (
          <svg key={i} viewBox="0 0 20 20" className="h-3.5 w-3.5" fill={i < full ? "#fdb913" : (i < rating ? "#fdb913" : "#e2e6f0")}>
            <path d="M10 1.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L10 15l-5.2 2.6 1-5.8L1.5 7.7l5.9-.9z" />
          </svg>
        ))}
      </div>
      <p className="mt-0.5 text-xs font-medium text-[#12142b]">{rating} <span className="text-[#565b73]">({count})</span></p>
    </div>
  );
};

export { money };
